import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import hubDaive from './assets/hubdaive.png';
import MenuLateral from './components/MenuLateral.jsx';
import MenuProfile from './components/MenuProfile.jsx';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const agentConfigs = {
  'briefing': { name: 'Agente Briefador', color: '#007AFF', tagline: 'Assistente Geral' },
  'conteudo': { name: 'Agente de Conteúdo', color: '#FF9500', tagline: 'Monitorando Tendências' },
  'estrategico': { name: 'Agente de Estratégia', color: '#AF52DE', tagline: 'Análise Profunda' },
  'redacao': { name: 'Agente de Redação', color: '#dbff10', tagline: 'Criação de Conteúdo' },
  'roteiro': { name: 'Agente de Roteiro', color: '#c60000', tagline: 'Desenvolvimento de Roteiros' },
  'pim': { name: 'Agente de PIM', color: '#ee90e9', tagline: 'Planejamento Integrado de Marcas' },
  'agente-gov': { name: 'Agente de Dados GOV MS', color: '#0c8322', tagline: 'Análise de Dados' }
  };


function Chat() {
    const navigate = useNavigate();
    const { agentType } = useParams();
    const [input, setInput] = useState('');
    const [projectName, setProjectName] = useState(null);
    const [messages, setMessages] = useState([]);
    const [file, setFile] = useState(null);
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [sessionsLoading, setSessionsLoading] = useState(true);
    const currentAgent = agentConfigs[agentType] || agentConfigs['briefing'];
    const messagesEndRef = useRef(null);
    const textareaRef = useRef(null);
    const [chatVisible, setChatVisible] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [toastVisible, setToastVisible] = useState(false);
    const [searchParams] = useSearchParams();
    const newThread = searchParams.get('new_thread') === 'true';
    const projectId = searchParams.get('project_id');
    const [hoveredSessionId, setHoveredSessionId] = useState(null);
    const [sessionMenuId, setSessionMenuId] = useState(null);
    const [projects, setProjects] = useState([]);
    const [showProjectPicker, setShowProjectPicker] = useState(null);
    const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
    const [thinkingMode, setThinkingMode] = useState(false);
    
    const handleFileChange = (e) => {
            const selectedFiles = Array.from(e.target.files);
            setFiles(prev => [...prev, ...selectedFiles]);
        };
    
    const loadingPhrases = [
        "Pensando...",
        "Me aprofundando no assunto...",
        "Analisando informações...",
        "Consultando fontes...",
        "Saindo do raso..."
    ];
    const generateUUID = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };

    const [loadingPhraseIndex, setLoadingPhraseIndex] = useState(0);
    const [phraseVisible, setPhraseVisible] = useState(true);
        
    const removeFile = (index) => {
        setFiles(prev => prev.filter((_, i) => i !== index));
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const [sessions, setSessions] = useState([
        { id: generateUUID(), title: 'Primeira Pesquisa' }
    ]);
    
    const [currentThreadId, setCurrentThreadId] = useState(() => {
        if (newThread) return generateUUID(); 
        const threadFromUrl = searchParams.get('thread_id');
        return threadFromUrl || generateUUID();
    });

    useEffect(() => {
        if (newThread) {
            setCurrentThreadId(generateUUID());
            setMessages([]);
        }
    }, [agentType]);

    const handleDeleteConversation = async (threadId, e) => {
        e.stopPropagation();
        const token = localStorage.getItem('token');
        
        await fetch(`https://hubdaive.com.br/api/agente-pesquisa/conversations/${threadId}`, {
            method: "DELETE",
            headers: { "Authorization": `Bearer ${token}` }
        });

        setSessions(prev => prev.filter(s => s.id !== threadId));
        
        if (threadId === currentThreadId) {
            handleNewChat();
        }
    };

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    const isAtBottomRef = useRef(true);
    const messagesContainerRef = useRef(null);

    const handleScroll = () => {
        const container = messagesContainerRef.current;
        if (!container) return;
        const threshold = 100;
        isAtBottomRef.current = container.scrollHeight - container.scrollTop - container.clientHeight < threshold;
    };

    useEffect(() => {
        if (!isAtBottomRef.current) return;
        const container = messagesContainerRef.current;
        if (!container) return;
        container.scrollTop = container.scrollHeight;
    }, [messages]);

    useEffect(() => {
    const fetchHistory = async () => {
        if (!currentThreadId) return;
            
        try {
            const token = localStorage.getItem('token');
            const userUUID = localStorage.getItem('user_id');
            const historyEndpoint = agentType === 'agente-gov' 
                ? `https://hubdaive.com.br/api/agente-gov/history/${currentThreadId}`
                : `https://hubdaive.com.br/api/agente-pesquisa/history/${currentThreadId}?user_id=${userUUID}`;

            const response = await fetch(historyEndpoint, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });

            if (response.ok) {
                const data = await response.json();

                if (data.messages && data.messages.length > 0) {
                    const normalized = data.messages.map(msg => ({
                        ...msg,
                        content: msg.role === 'assistant' && Array.isArray(msg.content)
                            ? msg.content.map(block => block.text || '').join(' ')
                            : msg.content 
                    }));
                    setMessages(data.messages);
                }
            }
        } catch (error) {
            console.error("Erro ao carregar histórico:", error);
            // setMessages([]);
        }
    };
    
    fetchHistory();
    }, [currentThreadId]);

    const fetchSessions = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`https://hubdaive.com.br/api/agente-pesquisa/conversations?agent_type=${agentType}`, {
                    headers: { "Authorization": `Bearer ${token}` }
                });
                const data = await response.json();
                
                if (data.threads && data.threads.length > 0) {
                    const loadedSessions = data.threads.map(thread => ({
                        id: thread.id, 
                        title: thread.title 
                    }));
                    setSessions(loadedSessions);
                }
            } catch (error) {
                console.error("Erro ao carregar sidebar:", error);
            } finally {
                setSessionsLoading(false);
            }
        };
    
    useEffect(() => { fetchSessions(); }, [agentType]);
    
        useEffect(() => {
        const verifyToken = async () => {
          const token = localStorage.getItem('token');
          try {
            const response = await fetch(`https://hubdaive.com.br/api/verify-token`, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
    
            if (!response.ok) {
              throw new Error('Token verification failed');
            }
          } catch (error) {
            localStorage.removeItem('token');
            navigate('/');
          }
        };
    
        verifyToken();
      }, [navigate]);

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = "auto";
            
            const scrollHeight = textareaRef.current.scrollHeight;
            textareaRef.current.style.height = scrollHeight + "px";
        }
    }, [input]); 

    useEffect(() => {
        setChatVisible(false);
        setShowToast(true);
        setToastVisible(true);
        const timer = setTimeout(() => setChatVisible(true), 50);
        return () => clearTimeout(timer);
    }, [agentType]);
    
    useEffect(() => {
        if (!loading) return;
        
        const interval = setInterval(() => {
            setPhraseVisible(false);
            setTimeout(() => {
                setLoadingPhraseIndex(prev => (prev + 1) % loadingPhrases.length);
                setPhraseVisible(true);
            }, 300);
        }, 3000);
        
        return () => clearInterval(interval);
    }, [loading]);

    useEffect(() => {
        if (!projectId) return;
        const token = localStorage.getItem('token');
        fetch(`https://hubdaive.com.br/api/projects/${projectId}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
            .then(r => r.json())
            .then(data => setProjectName(data.name))
            .catch(() => {});
        }, [projectId]);
    
    const handleSendMessage = async () => {
        if (!input.trim() && !files.length === 0) return;
        isAtBottomRef.current = true; 

        const token = localStorage.getItem('token');
        const currentInput = input.trim();
        const currentFiles = files;
        const currentThinkingMode = thinkingMode; 
        
        const filesMetadata = files.map(f => ({
                name: f.name,
                extension: f.name.split('.').pop().toUpperCase()
            }));

        setMessages(prev => [...prev, { 
            role: 'user', 
            content: currentInput || "Análise de documento em anexo", 
            attachedFiles: filesMetadata.length > 0 ? filesMetadata : [] 
        }]);

        setFiles([]);
        
        setInput('');
        setLoading(true);

        try {
            let aiContent = "";
            setMessages(prev => [...prev, { role: 'assistant', content: '', streaming: true }]);

            const endpoint = agentType === 'agente-gov' ? 'ws/agente-gov' : 'ws/agente-pesquisa';
            const ws = new WebSocket(`wss://hubdaive.com.br/api/${endpoint}?token=${token}`);

            ws.onopen = async () => {
                const readFile = (f) => new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve({
                        file_name: f.name,
                        file_data: reader.result.split(',')[1]
                    });
                    reader.readAsDataURL(f);
                });

                const encodedFiles = currentFiles.length > 0 
                    ? await Promise.all(currentFiles.map(readFile)) 
                    : [];
                
                console.log("thinking_mode enviado:", currentThinkingMode);
                ws.send(JSON.stringify({
                    prompt: currentInput || "Analise os arquivos enviados.",
                    thread_id: String(currentThreadId),
                    agent_type: String(agentType || 'briefing'),
                    files: encodedFiles,
                    project_id: projectId || null,
                    thinking_mode: currentThinkingMode
                }));
            };

            ws.onmessage = (e) => {
                if (e.data === '[DONE]') {
                    ws.close();
                    return;
                }

                if (e.data.startsWith('[TITULO]')) {
                    const titulo = e.data.replace('[TITULO]', '').replace('[/TITULO]', '');
                    setSessions(prev => {
                        const exists = prev.some(s => s.id === currentThreadId);
                        if (exists) return prev.map(s => s.id === currentThreadId ? { ...s, title: titulo, projectId: projectId } : s);
                        else return [{ id: currentThreadId, title: titulo, projectId: projectId }, ...prev];
                    });
                    return;
                }

                if (e.data.startsWith('[EVENTO]')) {
                    const evento = e.data.replace('[EVENTO]', '').replace('[/EVENTO]', '');
                    setMessages(prev => {
                        const updated = [...prev];
                        updated[updated.length - 1] = { ...updated[updated.length - 1], evento };
                        return updated;
                    });
                    return;
                }

                aiContent += e.data;
                setMessages(prev => {
                    const updated = [...prev];
                    updated[updated.length - 1] = { role: 'assistant', content: aiContent, streaming: true };
                    return updated;
                });

                setLoading(false);
            };

            ws.onclose = () => {
                setMessages(prev => {
                    const updated = [...prev];
                    updated[updated.length - 1] = { ...updated[updated.length - 1], streaming: false };
                    return updated;
                });
                setLoading(false);
            };

            ws.onerror = () => {
                setMessages(prev => [...prev, { role: 'assistant', content: "Erro na conexão." }]);
                setLoading(false);
            };

        } catch (error) {
            console.error("Erro no chat:", error);
            setMessages(prev => [...prev, { role: 'assistant', content: "Erro na conexão." }]);
            setLoading(false);
        }
    };


    const handleNewChat = () => {
        const newUuid = generateUUID();
        setCurrentThreadId(newUuid);
        setMessages([]); 
        
        setSessions(prev => [
            { id: newUuid, title: `Nova Conversa` }, 
            ...prev
        ]);
    };

    useEffect(() => {
        const fetchProjects = async () => {
            const token = localStorage.getItem('token');
            try {
            const res = await fetch('https://hubdaive.com.br/api/projects', {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const data = await res.json();
            setProjects(Array.isArray(data) ? data : []);
            } catch (err) {
            console.error('Erro ao buscar projetos:', err);
            }
        };
        fetchProjects();
        }, []);

    
    return (
        <>
        <style>{`
            @keyframes fadeInOut {
                0%   { opacity: 0; transform: translateX(-6px); }
                10%  { opacity: 1; transform: translateX(0); }
                65%  { opacity: 1; }
                100% { opacity: 0; }
            }
            @keyframes spin {
                from { transform: rotate(0deg); }
                to { transform: rotate(360deg); }
            }
            .streaming-cursor::after {
                content: "▊";
                margin-left: 4px;
                color: ${currentAgent.color};
                animation: blink 0.8s infinite;
            }
            /* Estilos extras para Markdown */
            .markdown-body p { margin-bottom: 1.2vh; }
            .markdown-body ul, .markdown-body ol { margin-bottom: 1.2vh; padding-left: 1.5vw; }
            .markdown-body li { margin-bottom: 0.5vh; }
            .markdown-body h2, .markdown-body h3 { margin-top: 2vh; margin-bottom: 1vh; color: ${currentAgent.color}; }

             /* MOBILE */
            @media (max-width: 767px) {
                .chat-wrapper {
                width: 100vw !important;
                height: 95vh !important;
                border-radius: 8px !important;
                }
                .chat-sidebar-internal {
                position: absolute !important;
                left: 0; top: 0;
                height: 100 % !important;
                width: 75vw !important;
                z-index: 500;
                transform: translateX(-100%);
                transition: transform 0.25s ease;
                }
                .chat-sidebar-internal.open {
                transform: translateX(0);
                }
                .chat-logo { display: none !important; }
                .chat-toggle-btn { display: flex !important; }
                .chat-overlay { display: block !important; }
                .button-clipe { margin-left: 2.5vw }
                .button-send { margin-right: 3.5vw }
                .mobile-input { width: 82vw !important }
                .saudacao { margin-top: 30vh !important; }

            }

            .chat-toggle-btn { display: none; }
        `}</style>
        
        <div style={{
        position: 'relative',
        minHeight: '100vh',
        maxWidth:'100vw',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'white', 
        fontFamily: 'Helvetica',
        backgroundColor: '#000'
    }}>
         

    <img className="chat-logo" 
            src={hubDaive}
            alt="logo"
            style={{ position: 'absolute',
            top: '3%',          
            left: '4%',         
            width: '10vw',
            height: 'auto' }} 
        />
        
        
    
    <div className="chat-wrapper" style={{
    width: '93vw', height: '82vh', backgroundColor: '#1A1A1A',
    borderRadius: '15px', border: '1px solid #333', display: 'flex',
    boxShadow: '0 30px 60px rgba(0,0,0,0.7)', overflow: 'hidden', marginTop: '5vh',
    opacity: chatVisible ? 1 : 0, transition: 'opacity 0.5s ease',
}}>
    
        {/* 1. SIDEBAR */}
        <div className={`chat-sidebar-internal ${mobileSidebarOpen ? 'open' : ''}`} 
            style={{ 
            width: '17vw',
            backgroundColor: '#141414', 
            borderRight: '1px solid #222', 
            padding: '20px', 
            display: 'flex', 
            flexDirection: 'column'
        }}>
            <button 
                onClick={handleNewChat}
                style={{ 
                    backgroundColor: '#007AFF', color: 'white', border: 'none', borderRadius: '8px', 
                    padding: '12px', marginBottom: '20px', cursor: 'pointer', fontWeight: 'bold' , fontSize:'2.3vh'
                }}>
                + Nova Conversa
            </button>

            <p style={{ color: '#888', fontSize: '2vh', marginBottom: '15px', fontWeight: 'bold', letterSpacing: '1px' }}>HISTÓRICO</p>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', overflowY: 'auto', flex: 1 }}>
                {sessionsLoading ? (
                    <>
                        {[...Array(20)].map((_, i) => (
                            <div key={i} style={{
                                height: '42px',
                                borderRadius: '8px',
                                background: 'linear-gradient(90deg, #222 25%, #2a2a2a 50%, #222 75%)',
                                backgroundSize: '200% 100%',
                                animation: 'shimmer 1.4s infinite',
                            }} />
                        ))}
                        <style>{`
                            @keyframes shimmer {
                                0% { background-position: 200% 0; }
                                100% { background-position: -200% 0; }
                            }
                        `}</style>
                    </>
                ) : (
                sessions.map(session => (
                    <div
                    key={session.id}
                    style={{ position: 'relative' }}
                    onMouseEnter={() => setHoveredSessionId(session.id)}
                    onMouseLeave={() => { setHoveredSessionId(null); if (sessionMenuId === session.id) setSessionMenuId(null); }}
                    >
                    <div
                        onClick={() => setCurrentThreadId(session.id)}
                        style={{
                        backgroundColor: currentThreadId === session.id ? '#333' : 'transparent',
                        padding: '12px', borderRadius: '8px', color: '#fff', fontSize: '2.3vh', fontWeight: 'bold',
                        border: currentThreadId === session.id ? '1px solid #444' : '1px solid transparent',
                        cursor: 'pointer', transition: '0.2s',
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between'
                        }}
                    >
                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>
                        {session.projectId && <span style={{ marginRight: '4px', fontSize: '1.2vh' }}>📁</span>}
                        {session.title}
                        </span>
                        <span
                        onClick={e => { e.stopPropagation(); setSessionMenuId(sessionMenuId === session.id ? null : session.id); setShowProjectPicker(null); }}
                        style={{
                            opacity: hoveredSessionId === session.id ? 1 : 0,
                            transition: 'opacity 0.15s',
                            color: '#888', fontSize: '2.3vh', cursor: 'pointer', padding: '0 4px', flexShrink: 0
                        }}
                        >
                        ⋯
                        </span>
                    </div>

                    {/* Dropdown */}
                    {sessionMenuId === session.id && (
                        <div
                        onClick={e => e.stopPropagation()}
                        style={{
                            position: 'absolute', right: 0, top: '100%',
                            backgroundColor: '#1a1a1a', border: '1px solid #333',
                            borderRadius: '8px', zIndex: 100, minWidth: '180px', overflow: 'visible'
                        }}
                        >
                        {/* Adicionar a projeto */}
                        <div
                            onClick={() => setShowProjectPicker(showProjectPicker === session.id ? null : session.id)}
                            style={{ padding: '10px 14px', fontSize: '1.8vh', color: '#ccc', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#262626'}
                            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                        >
                            📁 Adicionar a projeto
                            <span style={{ color: '#555' }}>›</span>
                        </div>

                        {/* Submenu de projetos */}
                        {showProjectPicker === session.id && (
                            <div style={{
                            position: 'absolute', left: 0, top: '100%',
                            backgroundColor: '#1a1a1a', border: '1px solid #333',
                            borderRadius: '8px', minWidth: '160px', overflow: 'hidden', zIndex: 101
                            }}>
                            {projects.length === 0 ? (
                                <div style={{ padding: '10px 14px', fontSize: '1.2vh', color: '#555' }}>Nenhum projeto</div>
                            ) : (
                                projects.map(p => (
                                <div
                                    key={p.id}
                                    onClick={async () => {
                                    const token = localStorage.getItem('token');
                                    await fetch(`https://hubdaive.com.br/api/projects/${p.id}/threads/${session.id}`, {
                                        method: 'POST',
                                        headers: { 'Authorization': `Bearer ${token}` }
                                    });
                                    setSessionMenuId(null);
                                    setShowProjectPicker(null);
                                    }}
                                    style={{ padding: '10px 14px', fontSize: '1.8vh', color: '#ccc', cursor: 'pointer' }}
                                    onMouseEnter={e => e.currentTarget.style.backgroundColor = '#262626'}
                                    onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                                >
                                    {p.name}
                                </div>
                                ))
                            )}
                            </div>
                        )}

                        {/* Deletar */}
                        <div
                            onClick={(e) => handleDeleteConversation(session.id, e)}
                            style={{ padding: '10px 14px', fontSize: '1.8vh', color: '#ff4444', cursor: 'pointer' }}
                            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#262626'}
                            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                        >
                            🗑️ Deletar
                        </div>
                        </div>
                    )}
                    </div>
                ))
            )}
            </div>
        </div>

        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', backgroundColor: '#111' }}>
            
            {/* Cabeçalho do Agente */}
            <div style={{ 
                padding: '15px 25px', 
                borderBottom: '1px solid #222', 
                display: 'flex', 
                alignItems: 'center',
                justifyContent: 'space-between'
            }}>
                {/* Botão só aparece no mobile */}
                <button
                    className="chat-toggle-btn"
                    onClick={() => setMobileSidebarOpen(o => !o)}
                    style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', fontSize: '20px', alignItems: 'center' }}
                >
                    ☰
                </button>

                {/* Overlay mobile */}
                {mobileSidebarOpen && (
                <div
                    onClick={() => setMobileSidebarOpen(false)}
                    style={{
                    display: 'none', // CSS sobrescreve no mobile
                    position: 'absolute', inset: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    zIndex: 499,
                    }}
                    className="chat-overlay"
                />
                )}
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <span style={{ color: currentAgent.color, fontWeight: 'bold', fontSize: '2vh' }}>
                        {currentAgent.name}
                    </span>
                    <div style={{ display: 'flex', backgroundColor: '#1a1a1a', borderRadius: '20px', border: '1px solid #333', overflow: 'hidden' }}>
                        <button
                            onClick={() => setThinkingMode(false)}
                            style={{
                                padding: '4px 12px',
                                background: !thinkingMode ? currentAgent.color : 'transparent',
                                border: 'none',
                                color: !thinkingMode ? '#000' : '#555',
                                fontSize: '1.2vh',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'all 0.2s'
                            }}
                        >
                            ⚡ Rápido
                        </button>
                        <button
                            onClick={() => setThinkingMode(true)}
                            style={{
                                padding: '4px 12px',
                                background: thinkingMode ? currentAgent.color : 'transparent',
                                border: 'none',
                                color: thinkingMode ? '#000' : '#555',
                                fontSize: '1.2vh',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'all 0.2s'
                            }}
                        >
                            🧠 Raciocínio
                        </button>
                    </div>

                    {/* ✅ Toast inline */}
                    {showToast && (
                    <span
                        onAnimationEnd={() => setShowToast(false)}
                        style={{
                            backgroundColor: currentAgent.color + '22',
                            color: currentAgent.color,
                            border: `1px solid ${currentAgent.color}55`,
                            borderRadius: '6px',
                            padding: '3px 10px',
                            fontSize: '1.5vh',
                            fontWeight: 'bold',
                            animation: 'fadeInOut 3s ease forwards',
                            pointerEvents: 'none'
                        }}
                    >
                        Instruções alteradas!
                    </span>
                )}
                </div>
            </div>

            {/* Área de Mensagens */}
            <div ref={messagesContainerRef}
                 onScroll={handleScroll} 
                 style={{ flex: 1 ,padding: '25px', minWidth:0 , overflow: 'hidden auto', display: 'flex', flexDirection: 'column', gap: '2vh' }}>
                {messages.length === 0 && (
                    <div className = "saudacao" style={{ color: '#444', textAlign: 'center', marginTop: '15%', fontSize: '2vh', fontWeight: 'bold' }}>
                        Como posso ajudar hoje?
                    </div>
                )}
                
                {messages.map((msg, i) => (
                    <div key={i} style={{
                        maxWidth: '75%',
                        padding: '0.5vh 1.0vw', 
                        borderRadius: '12px', 
                        color: '#fff', 
                        fontSize: '2vh',
                        fontFamily:'Helvetica', 
                        lineHeight: '1.4',
                        alignSelf: msg.role === 'user' ? 'flex-end' : 'flex-start',
                        backgroundColor: msg.role === 'user' ? '#007AFF' : '#262626',
                        border: msg.role === 'user' ? 'none' : '1px solid #333',
                        overflowWrap: 'break-word',  // ✅ adiciona
                        minWidth: 0,                 // ✅ adiciona
                        wordBreak: 'break-word',
                        display: 'flex',
                        flexDirection: 'column' 
                    }}>
                        {/* ✅ Evento da ferramenta */}
                        {msg.evento && (
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                marginBottom: '10px',
                                padding: '6px 10px',
                                backgroundColor: currentAgent.color + '15',
                                border: `1px solid ${currentAgent.color}33`,
                                borderRadius: '8px',
                                fontSize: '2vh',
                                color: currentAgent.color,
                                fontStyle: 'italic'
                            }}>
                                <div style={{
                                    width: '10px',
                                    height: '10px',
                                    border: `2px solid ${currentAgent.color}`,
                                    borderTop: '2px solid transparent',
                                    borderRadius: '50%',
                                    animation: 'spin 1s linear infinite',
                                    flexShrink: 0
                                }} />
                                {msg.evento}
                            </div>
                        )}
                        {/* EXIBIÇÃO DOS ARQUIVOS NA MENSAGEM ENVIADA */}
                        {msg.attachedFiles && msg.attachedFiles.length > 0 && (
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', marginBottom: '10px' }}>
                                {msg.attachedFiles.map((f, idx) => (
                                    <div key={idx} style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        backgroundColor: 'rgba(0,0,0,0.2)',
                                        borderRadius: '8px',
                                        padding: '5px 10px',
                                        border: '1px solid rgba(255,255,255,0.1)'
                                    }}>
                                        <div style={{ 
                                            backgroundColor: f.name?.endsWith('.mp3') ? '#FF9500' : 
                                                             f.name?.endsWith('.pdf') ? '#FF4B4B' : '#007AFF', 
                                            padding: '2px 4px', borderRadius: '3px', color: 'white', fontSize: '2.3vh', fontWeight: 'bold' 
                                        }}>
                                            {f?.name ? f.name?.split('.').pop().toUpperCase() : ''}
                                        </div> 
                                        <span style={{ fontSize: '2.3vh', color: '#fff' }}>{f.name}</span> 
                                    </div>
                                ))}
                            </div>
                        )}

                        <ReactMarkdown 
                            key={msg.content.length} 
                            remarkPlugins={[remarkGfm]}
                            components={{
                                p: ({children}) => <p style={{ marginBottom: '1.5rem', display: 'block',fontSize:'2.3vh'}}>{children}</p>,
                                h1: ({children}) => <h1 style={{ marginTop: '2rem', marginBottom: '1rem', fontWeight: 'bold', fontSize:'2.3vh'}}>{children}</h1>,
                                h2: ({children}) => <h2 style={{ marginTop: '2rem', marginBottom: '1rem', fontWeight: 'bold', fontSize:'2.3vh'}}>{children}</h2>,
                                ul: ({children}) => <ul style={{ paddingLeft: '1.5rem', marginBottom: '1.5rem', fontSize:'2.3vh' }}>{children}</ul>,
                                li: ({children}) => <li style={{ marginBottom: '0.5rem', listStyleType: 'disc', fontSize:'2.3vh' }}>{children}</li>,
                                a: ({href, children}) => <a href={href} style={{ color: '#ffffff', wordBreak: 'break-all' }} target="_blank">{children}</a>,
                                table: ({node, ...props}) => (
                                    <div style={{ width: '100%', overflowX: 'auto', margin: '10px 0', border: '1px solid #333', borderRadius: '8px' }}>
                                        <table {...props} style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: '#161616', fontSize: '1.8vh' }} />
                                    </div>
                                ),
                                thead: ({node, ...props}) => <thead {...props} style={{ backgroundColor: '#222', textAlign: 'left' }} />,
                                th: ({node, ...props}) => <th {...props} style={{ padding: '2vh 1vw', borderBottom: '1px solid #333', color: currentAgent.color, whiteSpace: 'nowrap',fontSize:'1.8vh' }} />,
                                td: ({node, ...props}) => <td {...props} style={{ padding: '10px', borderBottom: '1px solid #222', color: '#ccc',fontSize:'1.8vh' }} />,
                            }}
                            >
                            {msg.content}
                        </ReactMarkdown>
                    </div>
                ))}
                {loading && (
                            <div style={{ 
                                color: '#007AFF', 
                                fontSize: '2vh', 
                                marginLeft: '5px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}>
                                <div style={{
                                    width: '16px',
                                    height: '16px',
                                    border: '2px solid #007AFF',
                                    borderTop: '2px solid transparent',
                                    borderRadius: '50%',
                                    animation: 'spin 1s linear infinite',
                                    flexShrink: 0
                                }} />
                                <span style={{
                                    opacity: phraseVisible ? 1 : 0,
                                    transform: phraseVisible ? 'translateY(0)' : 'translateY(8px)',
                                    transition: 'opacity 0.3s ease, transform 0.3s ease',
                                    display: 'inline-block'
                                }}>
                                    {loadingPhrases[loadingPhraseIndex]}
                                </span>
                            </div>
                        )}
                    <div ref={messagesEndRef} />
            </div>

            {/* Área do Input (Rodapé) */}
            <div style={{ padding: '2vh 2vw', borderTop: '1px solid #222', backgroundColor: '#161616' }}>
                {files.length > 0 && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '10px' }}>
                        {files.map((f, idx) => (
                            <div key={idx} style={{
                                display: 'flex', alignItems: 'center', gap: '10px',
                                backgroundColor: '#262626', borderRadius: '12px',
                                padding: '1vh 0.5vw', border: '1px solid #333'
                            }}>
                                <div style={{ 
                                    backgroundColor: f.name.endsWith('.pdf') ? '#FF4B4B' : 
                                                    f.name.endsWith('.mp3') ? '#FF9500' : '#007AFF', 
                                    padding: '2px 6px', borderRadius: '4px', color: 'white', fontSize: '10px', fontWeight: 'bold' 
                                }}>
                                    {f.name.split('.').pop().toUpperCase()}
                                </div>
                                <span style={{ color: '#eee', fontSize: '1.2vh', maxWidth: '120px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {f.name}
                                </span>
                                <div onClick={() => removeFile(idx)} style={{ cursor: 'pointer', fontSize: '12px', color: '#888' }}>✕</div>
                            </div>
                        ))}
                    </div>
                )}
                <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                    {/* Input de Arquivo Invisível */}
                <input 
                    type="file" 
                    ref={fileInputRef}
                    multiple
                    style={{ display: 'none' }} 
                    onChange={(e) => setFiles(prev => [...prev, ...Array.from(e.target.files)])}
                    accept=".pdf,.docx,.txt,.mp3"
                />

                {/* Botão de Clipe */}
                <button className="button-clipe"
                    onClick={() => fileInputRef.current.click()}
                    style={{ 
                        position: 'absolute', 
                        left: '-1.4vw', 
                        background: 'none', 
                        border: 'none', 
                        color: '#4CD964',
                        cursor: 'pointer', 
                        fontSize: '2vh',
                        zIndex: 10
                    }}
                >
                    +
                </button>
                    <textarea className="mobile-input"
                    ref={textareaRef}
                    rows={1}
                    value={input}
                        style={{
                            width: '95%',
                            minHeight:'4.5vh',
                            maxHeight: '10vh',
                            lineHeight: '2.25vh',
                            resize: 'none',
                            backgroundColor: '#000',
                            border: '1px solid #333',
                            borderRadius: '12px',
                            padding: '12px 65px 12px 15px', 
                            fontSize: '1.8vh',
                            fontFamily:'Helvetica',
                            color: '#fff',
                            outline: 'none',
                            fontFamily: 'inherit',
                            overflowWrap: 'anywhere', 
                            wordBreak: 'normal',
                            whiteSpace: 'pre-wrap',
                            overflowY: 'auto',
                            boxSizing: 'border-box'
                        }}
                        onChange={(e) => setInput(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && !e.shiftKey) {
                                e.preventDefault();
                                handleSendMessage();
                            }
                        }}
                    />

                    {/* Botão de ícone opcional no final do input */}
                    <button className = "button-send"
                        onClick={handleSendMessage}
                        style={{ position: 'absolute', right: '-2vh', background: 'none', border: 'none', color: '#007AFF', cursor: 'pointer', fontWeight: 'bold',fontSize:'1.8vh' }}>
                        Enviar
                    </button>
                </div>
            </div>
        </div>
    </div>
    </div>
    </>
    )
}

export default Chat;